import React from 'react'
import { Link } from 'react-router-dom'
import { withContext } from '../../../utils/withContext'
import { array, object } from 'prop-types'
import styles from './Challenges.styl'

// scrollIntoView({ behavior: 'smooth', block: 'start' })
class Challenges extends React.Component {

	static propTypes = {
		services: array,
		context: object
	}

	scrollToElement(hash) {
		if (!hash || !window) { return }
		this.scrollElement = !this.scrollElement ? window.document.querySelector(hash) : null
		if (this.scrollElement) {
			this.scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
			this.scrollElement = null
		}
	}

	render() {
		const { services, context: { i18n, createLocaleLink } } = this.props
		if (!services) { return null }
		const sectionBlocks = (services || []).map((service, index) => {
			const { card: { title, summary }, images } = service
			const backgroundImage = images && Array.isArray(images) && images.length ? `url(${ images[0] })` : null

			return (
				<Link
					key={ index }
					to={ createLocaleLink(`/challenges/${ service.id }`) }
					className={ styles['challenge-container'] }
					style={ { backgroundImage } }
				>
					<div />
					<h3>{ title }</h3>
					<p>{ summary }</p>
				</Link>
			)
		})
		return (
			<section id="challenges" className={ styles['section'] } >
				<div className={ styles['content'] }>
					<div className={ styles['cards-container'] }>
						<div className={ styles['first-card'] }>
							<h4>{ i18n`objectives_subtitle_label` }</h4>
							<h2>{ i18n`objectives_title_label` }</h2>
							<p>{ i18n`objectives_summary_label` }</p>
						</div>
						{ sectionBlocks }
					</div>

					<div className={ styles.buttonDown } onClick={ () => { this.scrollToElement('#mission') } }>
						<div className={ styles.arrowDiv }>
							<div>
								<div dangerouslySetInnerHTML={ { __html: i18n`objectives_nextpage_link_label` } } />
								<icon className={ styles.arrowIcon } />
							</div>
						</div>
					</div>

				</div>
			</section>
		)
	}
}

export default withContext(Challenges)



// WEBPACK FOOTER //
// ./src/client/website/components/Challenges/Challenges.js